import { Box } from '@mui/material';
import { mergeSx } from 'merge-sx';

import { AbgTypography } from '@abg/kit-base';

import { addAttributes, sanitizeHtml } from '../../shared/utils';
import { applyRenewalTextReplacement } from '../../shared/utils/string-formatters';

import { HeadlineAndDescriptionProperties } from './headline-and-description.types';
import { isHtml } from './utils';

export const HeadlineAndDescription: React.FC<
  HeadlineAndDescriptionProperties
> = ({
  bannerType,
  title,
  fallbackTitle,
  subTitle,
  titleTestId,
  subtitleTestId,
  titleVariant = 'h3',
  subtitleVariant,
  styleParts = {},
  defaultStyles,
  confirmationNumber,
  avisFirstSubtitle,
  isAvisFirst,
  isRenewal,
}) => {
  const titleStyles = mergeSx(defaultStyles.title, styleParts.title);
  const subtitleStyles = mergeSx(defaultStyles.subtitle, styleParts.subtitle);
  const avisFirstSubtitleStyles = mergeSx(
    defaultStyles.avisFirstSubtitle,
    styleParts.avisFirstSubtitle,
  );
  const avisFirstSubtitleWrapper = mergeSx(
    defaultStyles.avisFirstSubtitleWrapper,
    styleParts.avisFirstSubtitleWrapper,
  );

  const avisFirstSubTitleSection = (
    <Box sx={avisFirstSubtitleWrapper}>
      <AbgTypography
        {...(subtitleVariant && { variant: subtitleVariant })}
        sx={avisFirstSubtitleStyles}
        data-testid={subtitleTestId}
      >
        {avisFirstSubtitle}
      </AbgTypography>
      <AbgTypography
        {...(subtitleVariant && { variant: subtitleVariant })}
        sx={subtitleStyles}
        data-testid={`${subtitleTestId}-confirmation-number`}
      >
        {confirmationNumber}
      </AbgTypography>
    </Box>
  );

  const subTitleSection = (
    <AbgTypography
      {...(subtitleVariant && { variant: subtitleVariant })}
      sx={subtitleStyles}
      data-testid={subtitleTestId}
    >
      {subTitle}
    </AbgTypography>
  );

  const currentSubtitleSection = isAvisFirst
    ? avisFirstSubTitleSection
    : subTitleSection;

  const displayTitle = applyRenewalTextReplacement(title, !!isRenewal);
  return (
    <>
      {displayTitle && (
        <AbgTypography
          variant={titleVariant}
          sx={titleStyles}
          data-testid={titleTestId}
        >
          {displayTitle}
        </AbgTypography>
      )}
      {bannerType === 'popular locations' && !displayTitle && fallbackTitle && (
        <AbgTypography
          variant={titleVariant}
          sx={titleStyles}
          data-testid={fallbackTitle.titleTestId}
        >
          {fallbackTitle.prefix}
          {fallbackTitle.title} ({fallbackTitle.mnemonic})
        </AbgTypography>
      )}
      {subTitle &&
        (isHtml(subTitle) ? (
          <AbgTypography
            {...(subtitleVariant && { variant: subtitleVariant })}
            component="div"
            sx={subtitleStyles}
            data-testid={subtitleTestId}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(
                addAttributes(subTitle || '', [
                  { tag: 'img', attributes: { alt: displayTitle || '' } },
                ]),
              ),
            }}
          />
        ) : (
          currentSubtitleSection
        ))}
    </>
  );
};
